import $ from 'jquery';
import Swiper, { Pagination, Navigation, Autoplay} from 'swiper';

function initIconCardsCarousel() {
    $(function () {
        if ($('.slider-block').length <= 0) {
            return;
        }

        $('.icon-cards-carousel').each(function () {
            const slider = $(this).find('.slider-block');
            const pagination = $(this).find('.swiper-pagination');
            let content = $(this).find('.icon-cards-carousel__list').html();
            $(this).find('.icon-cards-carousel__list').append(content);
            new Swiper(slider.get(0), {
                modules: [Pagination, Navigation , Autoplay],
                slidesPerView: 2, // Default value for large screens
                spaceBetween: 20,
                loop: true,
                //centeredSlides: true,
                pagination: {
                    el: pagination.get(0),
                    clickable: true,
                },
                navigation: {
                    nextEl: slider.find('.swiper-button-next').get(0),
                    prevEl: slider.find('.swiper-button-prev').get(0),
                },
                autoplay: {
                    //delay: 3000,
                },
                watchOverflow: true, // Automatically hide pagination if all slides fit
                breakpoints: {
                    576: {
                        spaceBetween: 20,
                        slidesPerView: 2, // Mobile
                    },
                    768: {
                        spaceBetween: 20,
                        slidesPerView: 4, // Tablet
                    },
                    1024: {
                        spaceBetween: 44,
                        slidesPerView: 6, // Desktop
                        slidesPerGroup: 2,
                    },
                },
                on: {
                    init: function () {
                        addActiveClass(this);
                    },
                    slideChange: function () {
                        addActiveClass(this);
                    },
                    resize: function () {
                        addActiveClass(this);
                    }
                }
            });
        });
    });

    function addActiveClass(swiper) {
        swiper.slides.forEach(slide => {
            slide.classList.remove(
              'custom-active',
              'visible-1',
              'visible-2',
              'visible-3',
              'visible-4',
              'visible-5',
              'visible-6'
            );
          });
        
          const startIndex = swiper.activeIndex;
          for (let i = 0; i < swiper.params.slidesPerView; i++) {
            const slide = swiper.slides[startIndex + i];
            if (slide) {
              slide.classList.add('custom-active', `visible-${i + 1}`);
            }
          }
    }
}

export { initIconCardsCarousel };
